import { getDirectiveSpec } from 'components/directive/utils/directiveSpecs'
import { DirectiveLPPageProps } from 'components/directive/utils/types'
import React, { useEffect, useMemo } from 'react'
import { mutateAnalyticsData } from 'utils/analytics'
import { LegacyDirectiveLandingPage } from 'components/directive/directiveLandingPage/legacy/LegacyDirectiveLandingPage'
import { ModernDirectiveLandingPage } from 'components/directive/directiveLandingPage/modern/ModernDirectiveLandingPage'

export const DirectiveLandingPage = ({
  variant,
  ...props
}: DirectiveLPPageProps & { variant: 'legacy' | 'modern' }) => {
  const spec = useMemo(() => getDirectiveSpec(props.directiveType), [props.directiveType])

  useEffect(() => {
    const { analyticsDirectiveType } = spec

    mutateAnalyticsData({ page: analyticsDirectiveType })
  }, [spec])

  return variant === 'legacy' ? (
    <LegacyDirectiveLandingPage {...props} />
  ) : (
    <ModernDirectiveLandingPage {...props} />
  )
}
